// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__8rMep","hidden":"styles_hidden__sPet1","shown":"styles_shown__7mgWA"};